import { useMandatorContext } from "@bn/theming";
import { useLocation } from "react-router";
import { useMandatorLinks } from "@hooks/useMandatorLinks";

export const useSupportLink = (): string => {
  const { supportUrl } = useMandatorLinks();
  const { config } = useMandatorContext();
  const location = useLocation();

  if (supportUrl.startsWith("https://")) {
    const currentUrl = encodeURIComponent(
      `${window.location.origin}${location.pathname}${location.search}${location.hash}`
    );
    return `${supportUrl}${currentUrl}`;
  }

  return `${supportUrl}?subject=Feedback an das ${config.name} Team`;
};
